import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModulComponent } from './modul.component';
import { AddModulComponent } from './add-modul/add-modul.component';
import { EditModulComponent } from './edit-modul/edit-modul.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [
        ModulComponent,
        AddModulComponent,
        EditModulComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
    ],
    exports: [ModulComponent]
})
export class ModulModule { }
